import { Container } from '@mui/material';
import { ExerciseDetail } from 'components/templates';
import React from 'react';
import { useParams } from 'react-router-dom';

export const ExerciseDetailView = () => {
  const { exerciseId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <ExerciseDetail id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
